import React, { useState } from "react";
import { Button } from "@mui/material";
import { Star, StarBorder } from "@mui/icons-material";
import { Trans } from "react-i18next";
import ApiServices from "../../services";

const SetDefaultButton = ({ 
  signature, 
  token,
  onSuccess,
  fullWidth = true,
  size = "small",
  sx = { mt: 1, mb: 1 }
}) => {
  const [isSettingDefault, setIsSettingDefault] = useState(false);

  const handleSetDefault = async (e) => {
    if (e) e.stopPropagation();
    if (signature.default_signature === 1) return;
    
    setIsSettingDefault(true);
    try {
      const res = await ApiServices.setDefaultSignature({ 
        token, 
        id: signature.id 
      });
      if (res.success && onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error("Error setting default signature:", error);
    } finally {
      setIsSettingDefault(false);
    }
  };

  return (
    <Button
      size={size}
      variant={signature.default_signature === 1 ? "contained" : "outlined"}
      color="warning"
      fullWidth={fullWidth}
      startIcon={signature.default_signature === 1 ? <Star /> : <StarBorder />}
      onClick={handleSetDefault}
      disabled={signature.default_signature === 1 || isSettingDefault}
      sx={sx}
    >
      {isSettingDefault ? (
        <Trans>Setting...</Trans>
      ) : signature.default_signature === 1 ? (
        <Trans>Default</Trans>
      ) : (
        <Trans>Set as Default</Trans>
      )}
    </Button>
  );
};

export default SetDefaultButton;

